import * as React from 'react';

interface Props {
  language: string;
  changeLanguage: () => void;
}

const IntlContext = React.createContext({} as Props)
export default IntlContext